// Localization data for all supported languages
const translations = {
  en: {
    savedICs: 'Saved ICs',
    newIC: 'New',
    noSavedICs: 'No saved ICs yet. Create a new one to get started.',
    saveCurrentIC: 'Save Current IC',
    saving: 'Saving...',
    icName: 'IC Name: (subckt)',
    enterICName: 'Enter IC name',
    verticalPins: 'Vertical Pins:',
    horizontalPins: 'Horizontal Pins:',
    max: 'Max:',
    description: 'Description:',
    enterICDescription: 'Enter IC description...',
    pinLabelsEditable: 'Pin labels are editable by clicking on them.',
    pinCheckboxes: 'Select the pin checkbox to simulate pin by default.',
    pinEraseToRemove: 'Erase the label to remove the pin, e.g., you need only lower 3 pins for MOSFET.',
    netlist: 'Netlist',
    enterNetlistContent: 'Enter your netlist content here...',
    deleteIC: 'Delete IC',
    deleteConfirmation: 'Are you sure you want to delete this IC? This action cannot be undone.',
    cancel: 'Cancel',
    delete: 'Delete',
    pins: 'Pins:'
  },
  ar: {
    savedICs: 'الدوائر المتكاملة المحفوظة',
    newIC: 'جديد',
    noSavedICs: 'لا توجد دوائر متكاملة محفوظة بعد. قم بإنشاء واحدة جديدة للبدء.',
    saveCurrentIC: 'حفظ الدائرة المتكاملة الحالية',
    saving: 'جاري الحفظ...',
    icName: 'اسم الدائرة المتكاملة: (subckt)',
    enterICName: 'أدخل اسم الدائرة المتكاملة',
    verticalPins: 'الدبابيس العمودية:',
    horizontalPins: 'الدبابيس الأفقية:',
    max: 'الحد الأقصى:',
    description: 'الوصف:',
    enterICDescription: 'أدخل وصف الدائرة المتكاملة...',
    pinLabelsEditable: 'يمكن تعديل تسميات الدبابيس بالنقر عليها.',
    pinCheckboxes: 'حدد مربع الاختيار للدبوس لمحاكاته افتراضيًا.',
    pinEraseToRemove: 'امسح التسمية لإزالة الدبوس، مثلاً: تحتاج فقط 3 دبابيس سفلية لـ MOSFET.',
    netlist: 'قائمة الشبكة',
    enterNetlistContent: 'أدخل محتوى قائمة الشبكة هنا...',
    deleteIC: 'حذف الدائرة المتكاملة',
    deleteConfirmation: 'هل أنت متأكد أنك تريد حذف هذه الدائرة المتكاملة؟ لا يمكن التراجع عن هذا الإجراء.',
    cancel: 'إلغاء',
    delete: 'حذف',
    pins: 'الدبابيس:'
  },
  de: {
    savedICs: 'Gespeicherte ICs',
    newIC: 'Neu',
    noSavedICs: 'Noch keine ICs gespeichert. Erstellen Sie einen neuen, um zu beginnen.',
    saveCurrentIC: 'Aktuellen IC speichern',
    saving: 'Speichern...',
    icName: 'IC-Name: (subckt)',
    enterICName: 'IC-Namen eingeben',
    verticalPins: 'Vertikale Pins:',
    horizontalPins: 'Horizontale Pins:',
    max: 'Max:',
    description: 'Beschreibung:',
    enterICDescription: 'IC-Beschreibung eingeben...',
    pinLabelsEditable: 'Pin-Beschriftungen können durch Anklicken bearbeitet werden.',
    pinCheckboxes: 'Aktivieren Sie das Kontrollkästchen, um den Pin standardmäßig zu simulieren.',
    pinEraseToRemove: 'Löschen Sie die Beschriftung, um den Pin zu entfernen, z.B. Sie benötigen nur die unteren 3 Pins für MOSFET.',
    netlist: 'Netzliste',
    enterNetlistContent: 'Geben Sie hier den Inhalt der Netzliste ein...',
    deleteIC: 'IC löschen',
    deleteConfirmation: 'Sind Sie sicher, dass Sie diesen IC löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    pins: 'Pins:'
  },
  fr: {
    savedICs: 'CIs enregistrés',
    newIC: 'Nouveau',
    noSavedICs: 'Aucun CI enregistré pour le moment. Créez-en un nouveau pour commencer.',
    saveCurrentIC: 'Enregistrer le CI actuel',
    saving: 'Enregistrement...',
    icName: 'Nom du CI: (subckt)',
    enterICName: 'Entrez le nom du CI',
    verticalPins: 'Broches verticales:',
    horizontalPins: 'Broches horizontales:',
    max: 'Max:',
    description: 'Description:',
    enterICDescription: 'Entrez la description du CI...',
    pinLabelsEditable: 'Les étiquettes des broches sont modifiables en cliquant dessus.',
    pinCheckboxes: 'Cochez la case pour simuler la broche par défaut.',
    pinEraseToRemove: 'Effacez l\'étiquette pour supprimer la broche, ex : vous n\'avez besoin que des 3 broches inférieures pour un MOSFET.',
    netlist: 'Liste de connexions',
    enterNetlistContent: 'Entrez le contenu de la liste de connexions ici...',
    deleteIC: 'Supprimer le CI',
    deleteConfirmation: 'Êtes-vous sûr de vouloir supprimer ce CI? Cette action ne peut pas être annulée.',
    cancel: 'Annuler',
    delete: 'Supprimer',
    pins: 'Broches:'
  },
  es: {
    savedICs: 'CIs guardados',
    newIC: 'Nuevo',
    noSavedICs: 'Aún no hay CIs guardados. Crea uno nuevo para comenzar.',
    saveCurrentIC: 'Guardar CI actual',
    saving: 'Guardando...',
    icName: 'Nombre del CI: (subckt)',
    enterICName: 'Ingrese el nombre del CI',
    verticalPins: 'Pines verticales:',
    horizontalPins: 'Pines horizontales:',
    max: 'Máx:',
    description: 'Descripción:',
    enterICDescription: 'Ingrese la descripción del CI...',
    pinLabelsEditable: 'Las etiquetas de los pines se pueden editar haciendo clic en ellas.',
    pinCheckboxes: 'Seleccione la casilla del pin para simularlo por defecto.',
    pinEraseToRemove: 'Borre la etiqueta para eliminar el pin, ej.: solo necesita los 3 pines inferiores para un MOSFET.',
    netlist: 'Lista de conexiones',
    enterNetlistContent: 'Ingrese el contenido de la lista de conexiones aquí...',
    deleteIC: 'Eliminar CI',
    deleteConfirmation: '¿Está seguro de que desea eliminar este CI? Esta acción no se puede deshacer.',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    pins: 'Pines:'
  },
  tr: {
    savedICs: 'Kaydedilmiş IC\'ler',
    newIC: 'Yeni',
    noSavedICs: 'Henüz kaydedilmiş IC yok. Başlamak için yeni bir tane oluşturun.',
    saveCurrentIC: 'Mevcut IC\'yi Kaydet',
    saving: 'Kaydediliyor...',
    icName: 'IC Adı: (subckt)',
    enterICName: 'IC adını girin',
    verticalPins: 'Dikey Pinler:',
    horizontalPins: 'Yatay Pinler:',
    max: 'Maks:',
    description: 'Açıklama:',
    enterICDescription: 'IC açıklamasını girin...',
    pinLabelsEditable: 'Pin etiketleri üzerlerine tıklanarak düzenlenebilir.',
    pinCheckboxes: 'Pini varsayılan olarak simüle etmek için onay kutusunu seçin.',
    pinEraseToRemove: 'Pini kaldırmak için etiketi silin, ör.: MOSFET için yalnızca alt 3 pime ihtiyacınız var.',
    netlist: 'Bağlantı Listesi',
    enterNetlistContent: 'Bağlantı listesi içeriğini buraya girin...',
    deleteIC: 'IC\'yi Sil',
    deleteConfirmation: 'Bu IC\'yi silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.',
    cancel: 'İptal',
    delete: 'Sil',
    pins: 'Pinler:'
  },
  th: {
    savedICs: 'ไอซีที่บันทึกไว้',
    newIC: 'ใหม่',
    noSavedICs: 'ยังไม่มีไอซีที่บันทึกไว้ สร้างใหม่เพื่อเริ่มต้น',
    saveCurrentIC: 'บันทึกไอซีปัจจุบัน',
    saving: 'กำลังบันทึก...',
    icName: 'ชื่อไอซี: (subckt)',
    enterICName: 'ป้อนชื่อไอซี',
    verticalPins: 'พินแนวตั้ง:',
    horizontalPins: 'พินแนวนอน:',
    max: 'สูงสุด:',
    description: 'คำอธิบาย:',
    enterICDescription: 'ป้อนคำอธิบายไอซี...',
    pinLabelsEditable: 'ป้ายกำกับพินสามารถแก้ไขได้โดยคลิกที่พิน',
    pinCheckboxes: 'เลือกช่องทำเครื่องหมายพินเพื่อจำลองพินโดยค่าเริ่มต้น',
    pinEraseToRemove: 'ลบป้ายกำกับเพื่อถอดพิน เช่น คุณต้องการเพียง 3 พินล่างสำหรับ MOSFET',
    netlist: 'รายการเครือข่าย',
    enterNetlistContent: 'ป้อนเนื้อหารายการเครือข่ายที่นี่...',
    deleteIC: 'ลบไอซี',
    deleteConfirmation: 'คุณแน่ใจหรือไม่ว่าต้องการลบไอซีนี้? การกระทำนี้ไม่สามารถยกเลิกได้',
    cancel: 'ยกเลิก',
    delete: 'ลบ',
    pins: 'พิน:'
  },
  mx: {
    savedICs: 'CIs guardados',
    newIC: 'Nuevo',
    noSavedICs: 'Aún no hay CIs guardados. Crea uno nuevo para comenzar.',
    saveCurrentIC: 'Guardar CI actual',
    saving: 'Guardando...',
    icName: 'Nombre del CI: (subckt)',
    enterICName: 'Ingrese el nombre del CI',
    verticalPins: 'Pines verticales:',
    horizontalPins: 'Pines horizontales:',
    max: 'Máx:',
    description: 'Descripción:',
    enterICDescription: 'Ingrese la descripción del CI...',
    pinLabelsEditable: 'Las etiquetas de los pines se pueden editar haciendo clic en ellas.',
    pinCheckboxes: 'Seleccione la casilla del pin para simularlo por defecto.',
    pinEraseToRemove: 'Borre la etiqueta para eliminar el pin, ej.: solo necesita los 3 pines inferiores para un MOSFET.',
    netlist: 'Lista de conexiones',
    enterNetlistContent: 'Ingrese el contenido de la lista de conexiones aquí...',
    deleteIC: 'Eliminar CI',
    deleteConfirmation: '¿Está seguro de que desea eliminar este CI? Esta acción no se puede deshacer.',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    pins: 'Pines:'
  }
};

export default translations;
